export default {
  closeButtonLabel: {
    id: 'checkout_services_mobile_plan_assistance_drawer_close_button_label',
    defaultMessage: 'Close {partnerLabel} assistance',
  },
  drawerTitle: {
    id: 'checkout_services_mobile_plan_assistance_drawer_drawer_title',
    defaultMessage: '{partnerLabel} assistance',
  },
  title: {
    id: 'checkout_services_mobile_plan_assistance_drawer_title',
    defaultMessage:
      'Bénéficiez de l’assistance {partnerLabel} pour votre forfait mobile',
  },
}
